'use es6';

import { createSelector } from 'reselect';

const getEcosystem = state => state.ecosystem;

export const getMarketplaceListings = createSelector([getEcosystem], ecosystem => ecosystem.marketplaceListings);